import type { WorkspaceSyncPolicy } from './types'

export const LOCAL_WORKSPACE_SYNC_MODE_KEY_PREFIX = 'sb:local-workspace-sync-mode:'

export function normalizeStoredWorkspaceSyncPolicy(raw: string | null): WorkspaceSyncPolicy {
    if (raw === 'paused' || raw === 'offline') return 'paused'
    if (raw === 'auto' || raw === 'live') return 'auto'
    if (raw === 'on-demand') return 'on-demand'
    return 'on-demand'
}

export function getLocalWorkspaceSyncPolicy(blobId: string): WorkspaceSyncPolicy {
    try {
        return normalizeStoredWorkspaceSyncPolicy(
            localStorage.getItem(`${LOCAL_WORKSPACE_SYNC_MODE_KEY_PREFIX}${blobId}`),
        )
    } catch {
        return 'on-demand'
    }
}

export function getExplicitLocalWorkspaceSyncPolicy(blobId: string): WorkspaceSyncPolicy | null {
    try {
        const raw = localStorage.getItem(`${LOCAL_WORKSPACE_SYNC_MODE_KEY_PREFIX}${blobId}`)
        return raw == null ? null : normalizeStoredWorkspaceSyncPolicy(raw)
    } catch {
        return null
    }
}

export function setLocalWorkspaceSyncPolicy(blobId: string, policy: WorkspaceSyncPolicy): void {
    try {
        localStorage.setItem(`${LOCAL_WORKSPACE_SYNC_MODE_KEY_PREFIX}${blobId}`, policy)
    } catch {
        // Local preference only; quota/privacy failures should not block workspace use.
    }
}
